import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=6fe26036&scoped=true&"
var script = {}
import style0 from "./Checkmark.vue?vue&type=style&index=0&id=6fe26036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe26036",
  null
  
)

export default component.exports